import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { fetchUser, signIn, signOut, verify2FA } from 'store/thunks/authThunk';
import { IUser } from 'types/users';

export interface IAuthState {
  token: string | null;
  loading: boolean;
  user: IUser | null;
  isAdmin: boolean;
  twoFARequired: boolean;
  isRemember: boolean;
}

const initialState: IAuthState = {
  token: null,
  loading: false,
  user: null,
  isAdmin: false,
  twoFARequired: false,
  isRemember: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    clearToken: (state) => {
      state.token = initialState.token;
    },
    setTwoFARequired: (state, action: PayloadAction<boolean>) => {
      state.twoFARequired = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false;
        state.token = null;
        state.user = null;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        const { token, twoFARequired } = action.payload;
        state.token = (token) ? token : null;
        state.twoFARequired = twoFARequired;
        state.isRemember = action.meta.arg.userData.isRemember || false;
      })
      .addCase(signIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.loading = false;
        state.user = null;
        //state.token = null;
        const payload = action.payload as { code?: number; data?: { token?: string } };
        if (payload?.code === 1005) {
            state.twoFARequired = true;
            state.isRemember = action.meta.arg.userData.isRemember || false;
        }
      })
      .addCase(verify2FA.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        state.twoFARequired = false;
      })
      .addCase(verify2FA.pending, (state) => {
        state.loading = true;
      })
      .addCase(verify2FA.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchUser.fulfilled, (state, { payload }) => {
        state.user = payload.data ? payload.data : null;
        state.loading = false;
      })
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUser.rejected, (state) => {
        state.user = null;
        state.loading = false;
        state.user = null;
      }),
});

export const selectUser = (state: RootState) => state.auth.user;
export const selectAuth = (state: RootState) => state.auth;

export const { setToken, clearToken, setTwoFARequired } = authSlice.actions;

export const authReducer = authSlice.reducer;
